
export const common = {
  // Navigation
  'nav.features': 'Funzionalità',
  'nav.howItWorks': 'Come funziona',
  'nav.pricing': 'Prezzi',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Chi siamo',
  'nav.getStarted': 'Inizia',

  // About Us Section
  'aboutUs.badge': 'Chi siamo',
  'aboutUs.title': 'Chi siamo',
  'aboutUs.line1': 'Le idee sono economiche.',
  'aboutUs.line2': 'Il capitale no. Il tempo ancora meno.',
  'aboutUs.paragraph1': 'IdeaOracle.ai è stata fondata perché la maggior parte delle idee di business non fallisce per mancanza di coraggio – ma per mancanza di onestà. Troppa validazione. Troppo poca realtà.',
  'aboutUs.belief1a': 'Non crediamo nel clamore.',
  'aboutUs.belief1b': 'Crediamo nella logica di mercato.',
  'aboutUs.belief2a': 'Non crediamo nella motivazione.',
  'aboutUs.belief2b': 'Crediamo nella domanda, nella concorrenza e nella differenziazione.',
  'aboutUs.mission1': 'Il nostro compito non è far sembrare belle le idee.',
  'aboutUs.mission2': 'Il nostro compito è rivelare la loro fattibilità.',
  'aboutUs.analysis': 'IdeaOracle.ai analizza le nicchie di business per meccanica strutturale del mercato, domanda realistica, intensità competitiva e fattibilità. Non emotivo. Non ottimista. Ma sobrio.',
  'aboutUs.failure1': 'La maggior parte delle idee fallisce.',
  'aboutUs.failure2': 'Non perché i fondatori siano incapaci –',
  'aboutUs.failure3': 'ma perché nessuno è stato abbastanza chiaro prima.',
  'aboutUs.clarity': 'Esistiamo per fornire quella chiarezza.',
  'aboutUs.value1': 'Scomodo.',
  'aboutUs.value2': 'Diretto.',
  'aboutUs.value3': 'Coerente.',
  // Fixed string: use double quotes to avoid escaping issues
  'aboutUs.confirm': "Se un'idea ha sostanza, la confermiamo.",
  'aboutUs.deny': 'Se no, lo diciamo ugualmente.',
  'aboutUs.noApplause': 'Senza applausi.',
  'aboutUs.noSugarcoating': 'Senza abbellimenti.',
  'aboutUs.noTheater': 'Senza teatro.',

  // Hero Section
  'hero.badge': 'IA decisionale per nicchie di business',
  'hero.title1': 'Le idee sono economiche.',
  'hero.title2': 'Le cattive decisioni non lo sono.',
  'hero.subtitle': 'Un\'IA che valuta la tua nicchia di business',
  'hero.subtitleLine2': 'prima che tu investa.',
  'hero.cta': 'Verifica idea',
  'hero.ctaSecondary': 'Come funziona',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Crediti per richiesta',
  'hero.stat2Value': 'Da 7',
  'hero.stat2Label': 'Livelli di valutazione',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Onesto e Privato',

  // Features Section
  'features.title1': 'Funzionalità potenti per',
  'features.title2': 'aziende',
  'features.title3': 'moderne',
  'features.honestVerdict.title': 'Verdetto onesto, non un punteggio hype',
  'features.honestVerdict.description': 'Verdetti buono/medio/debole netti, sostenuti da dati di mercato reali e analisi della concorrenza. Nessuna valutazione 9/10 pensata per lusingare ogni idea.',
  'features.fullJourney.title': 'Dal test dell’idea al Builder Report',
  'features.fullJourney.description': 'Valida in chat, approfondisci l’analisi di mercato, esporta un Builder Report da 25–75 pagine con persona, finanze, go-to-market e pitch deck.',
  'features.multilingual.title': '21 lingue, dati di mercato locali',
  'features.multilingual.description': 'Dalla PMI svizzera al fondatore solo a San Paolo — l’IA risponde nella tua lingua, con fonti dal tuo mercato.',

  // How It Works
  'howItWorks.title': 'Come funziona',
  'howItWorks.subtitle': 'Quattro passi verso la chiarezza sulla tua nicchia di business.',
  'howItWorks.step1Title': 'Scegli un piano',
  'howItWorks.step1Desc': 'Starter, Pro o Builder – a seconda della profondità della tua revisione.',
  'howItWorks.step2Title': 'Chiedi all\'IA',
  'howItWorks.step2Desc': 'Fai le tue domande sulla nicchia. Ogni richiesta costa 30 crediti.',
  'howItWorks.step3Title': 'Ottieni verdetto onesto',
  'howItWorks.step3Desc': 'L\'IA valuta: Buono, Medio o Cattivo. Senza giri di parole.',
  'howItWorks.step4Title': 'Prendi una decisione',
  'howItWorks.step4Desc': 'Ora sai se vale la pena andare avanti.',

  // Pricing
  'pricing.title': 'Prezzi',
  'pricing.subtitle': 'Scegli il piano che si adatta alla profondità della tua revisione.',
  'pricing.yearlyDiscount': 'Abbonamento annuale:',
  'pricing.yearlyDiscountValue': '-20% di sconto',
  'pricing.perMonth': 'al mese',
  'pricing.selectPlan': 'Seleziona piano',
  'pricing.mostPopular': 'Più popolare',
  'pricing.footer': 'Tutti i prezzi in CHF. I crediti vengono detratti solo per risposte IA riuscite.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Per test di realtà iniziali.',
  'pricing.starter.credits': '2.500 crediti',
  'pricing.starter.feature1': 'Genera idea di nicchia',
  'pricing.starter.feature2': 'Affina nicchia',
  'pricing.starter.feature3': 'Verifica realtà del mercato',
  'pricing.starter.feature4': 'Valutazione concorrenza',
  'pricing.starter.feature5': 'Valutazione tempistica',
  'pricing.starter.feature6': 'Verdetto onesto',
  'pricing.starter.feature7': 'Sessioni private',
  'pricing.starter.feature8': 'Cronologia ed esportazione',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Per revisione più approfondita.',
  'pricing.pro.credits': '5.000 crediti',
  'pricing.pro.feature1': 'Tutte le funzionalità Starter',
  'pricing.pro.feature2': 'Più crediti per revisione intensiva',
  'pricing.pro.feature3': 'Suggerimenti di miglioramento',
  'pricing.pro.feature4': 'Nicchie alternative',
  'pricing.pro.feature5': 'Analisi di mercato dettagliata',
  'pricing.pro.feature6': 'Supporto prioritario',
  'pricing.pro.feature7': 'Filtri avanzati',
  'pricing.pro.feature8': 'Preferiti di sessione',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idea → Briefing sviluppatore.',
  'pricing.builder.credits': 'Crediti illimitati',
  'pricing.builder.feature1': 'Tutte le funzionalità Pro',
  'pricing.builder.feature2': 'Richieste IA illimitate',
  'pricing.builder.feature3': 'Modalità Builder: Briefing sviluppatore',
  'pricing.builder.feature4': 'Panoramica strutturata del progetto',
  'pricing.builder.feature5': 'Flussi utente e funzioni principali',
  'pricing.builder.feature6': 'Note tecniche',
  'pricing.builder.feature7': 'Definisci non-obiettivi',
  'pricing.builder.feature8': 'Limite di tasso uso equo',
  'pricing.builder.limitNote': 'Limite uso equo',
  'pricing.monthlyReset': 'Reset mensile',

  // Modal
  'pricing.modal.selected': 'selezionato',
  'pricing.modal.comingSoon': 'La registrazione e l\'elaborazione dei pagamenti saranno presto disponibili.',
  'pricing.modal.patience': 'Stiamo lavorando per offrirti un\'esperienza sicura e fluida. Per favore, sii paziente.',
  'pricing.modal.understood': 'Capito',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Risposto onestamente e criticamente.',
  'faq.q1': 'Cosa fa concretamente IdeaOracle.ai?',
  'faq.a1': 'IdeaOracle.ai valuta idee di business e nicchie per logica di mercato, domanda reale, concorrenza, differenziazione e fattibilità.\nSe c\'è sostanza, mostriamo come può essere affinata strategicamente.\nSe no, lo diciamo.',
  'faq.q2': 'Generate anche idee?',
  'faq.a2': 'Sì.\nMa non alla cieca.\nSviluppiamo approcci basati sulla logica di mercato – non sulla motivazione o il clamore delle tendenze.',
  'faq.q3': 'Ottimizzate modelli di business?',
  'faq.a3': 'Sì – se esiste potenziale.\nNon lucidiamo illusioni.\nRendiamo i concetti fattibili più resistenti.',
  'faq.q4': 'Cosa vi distingue dagli altri strumenti IA?',
  'faq.a4': 'Altri strumenti forniscono ispirazione.\nNoi forniamo valutazione.\nIl focus è sul realismo, non sull\'entusiasmo.',
  'faq.q5': 'È una garanzia di successo?',
  'faq.a5': 'No.\nRiduciamo le decisioni sbagliate – non eliminiamo il rischio.',
  'faq.q6': 'A chi è destinato IdeaOracle.ai?',
  'faq.a6': 'Fondatori prima del lancio\nImprenditori prima dell\'espansione\nSide-builder prima dell\'investimento di tempo\nInvestitori prima della valutazione\n\nIn breve: Per persone che vogliono chiarezza prima del capitale.',
  'faq.q7': 'E se cerco solo conferma?',
  'faq.a7': 'Allora IdeaOracle.ai non è lo strumento giusto.',
  'faq.q8': 'Quanto è onesta l\'analisi?',
  'faq.a8': 'Tanto onesta quanto i dati e la meccanica di mercato lo consentono.\nNessuna euforia. Nessuna clemenza.',
  'faq.q9': 'Sostituite la ricerca di mercato?',
  'faq.a9': 'No.\nSiamo una pre-valutazione strategica – non uno studio di mercato completo.',
  'faq.q10': 'Perché così intransigenti?',
  'faq.a10': 'Perché fallire è costoso.\nL\'onestà no.',

  // Footer
  'footer.description': 'Questa piattaforma non ti aiuta a sentirti bene – ma a decidere correttamente.',
  'footer.product': 'Prodotto',
  'footer.aiAssistant': 'Assistente IA',
  'footer.howItWorks': 'Come funziona',
  'footer.pricing': 'Prezzi',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legale',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Termini',
  'footer.imprint': 'Impronta',
  'footer.support': 'Supporto',
  'footer.contact': 'Contatto',
  'footer.documentation': 'Documentazione',
  'footer.copyright': '© 2025 IdeaOracle.ai. Tutti i diritti riservati.',

  // AI Assistant
  'aiAssistant.title': 'Assistente IA di nicchia',
  'aiAssistant.subtitle': 'Domande sulle nicchie',
  'aiAssistant.welcomeMessage': 'Ciao! Descrivi la tua idea o chiedimi di una nicchia. Ti darò una valutazione chiara e onesta.',
  'aiAssistant.demoResponse': 'Questa è una demo. Per ottenere valutazioni IA reali, registrati e scegli un piano.',
  'aiAssistant.placeholder': 'Descrivi la tua idea...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.sidebar.overview': 'Panoramica',
  'dashboard.sidebar.newAnalysis': 'Assistente IA',
  'dashboard.sidebar.history': 'Cronologia',
  'dashboard.sidebar.credits': 'Crediti',
  'dashboard.sidebar.settings': 'Impostazioni',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Bentornato, {{name}}',
  'dashboard.overview.subtitle': 'Ecco una rapida panoramica della tua attività',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Crediti rimanenti',
  'dashboard.stats.totalAnalyses': 'Analisi totali',
  'dashboard.stats.goodRatings': 'Valutazioni positive',
  'dashboard.stats.nextReset': 'Prossimo reset tra',
  'dashboard.stats.days': 'giorni',

  // Quick Actions
  'dashboard.quickActions.title': 'Azioni rapide',
  'dashboard.quickActions.checkNewIdea': 'Verifica un\'idea',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analizza un\'idea di business esistente',
  'dashboard.quickActions.generateIdea': 'Genera un\'idea',
  'dashboard.quickActions.generateIdeaDesc': 'Trova una nuova nicchia redditizia',
  'dashboard.quickActions.builderBriefing': 'Briefing Builder',
  'dashboard.quickActions.builderBriefingDesc': 'Trasforma un\'idea in un briefing pronto per gli sviluppatori',
  'dashboard.quickActions.premiumOnly': 'Solo Builder',

  // Chat Header
  'chat.title': 'Assistente IA di nicchia',
  'chat.subtitle': 'Fai domande sulle nicchie. Valuto in modo critico e onesto.',
  'chat.creditsLabel': 'Crediti',

  // Chat Welcome
  'chat.welcomeTitle': 'Benvenuto nell\'Assistente IA di nicchia',
  'chat.welcomeDesc': 'Descrivi la tua idea o chiedi di una nicchia. La valuterò onestamente: Buono, Medio o Cattivo.',
  'chat.aiWelcome': 'Ciao! Descrivi la tua idea o chiedimi di una nicchia. Ti darò una valutazione chiara e onesta.',

  // Chat Suggestions
  'chat.suggestion1': 'Trovami una nicchia redditizia.',
  'chat.suggestion2': 'Ho un\'idea – valutala onestamente.',
  'chat.suggestion3': 'Quali nicchie hanno potenziale ora?',
  'chat.suggestion4': 'Affina questa nicchia e rendila più specifica.',

  // Chat Actions
  'chat.newConversation': 'Nuova conversazione',
  'chat.today': 'Oggi',
  'chat.yesterday': 'Ieri',
  'chat.thisWeek': 'Questa settimana',
  'chat.thisMonth': 'Questo mese',
  'chat.older': 'Più vecchio',
  'chat.messages': 'messaggi',
  'chat.renameConversation': 'Rinomina',
  'chat.deleteConversation': 'Elimina',
  'chat.cancel': 'Annulla',
  'chat.rename': 'Rinomina',
  'chat.delete': 'Elimina',
  'chat.favorite': 'Aggiungi preferito',
  'chat.unfavorite': 'Rimuovi preferito',
  'chat.searchSessions': 'Cerca conversazioni...',
  'chat.noResults': 'Nessun risultato trovato',
  'chat.noSessions': 'Ancora nessuna conversazione',
  'chat.enterNewName': 'Inserisci un nuovo nome...',
  'chat.deleteConfirmMessage': 'Sei sicuro di voler eliminare questa conversazione? Questa azione non può essere annullata.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Digita la tua domanda… (costa 30 crediti)',
  'chat.send': 'Invia',
  'chat.voice': 'Parla',
  'chat.listeningPlaceholder': 'Sto ascoltando... Parla ora.',
  'chat.stopListening': 'Ferma registrazione',
  'chat.recording': 'Registrazione...',
  'chat.speechNotSupported': 'Il riconoscimento vocale non è supportato dal tuo browser.',
  'chat.microphonePermissionDenied': 'L\'accesso al microfono è stato negato. Per favore, consenti l\'accesso nelle impostazioni del browser.',
  'chat.errorNotEnoughCredits': 'Crediti insufficienti. Per favore, aggiorna il tuo piano o attendi il prossimo reset.',
  'chat.errorAiFailed': 'La risposta IA è fallita. Nessun credito è stato detratto.',
  'chat.errorRateLimit': 'Troppe richieste. Per favore, attendi un momento.',

  // Ratings
  'rating.good': 'Buono',
  'rating.medium': 'Medio',
  'rating.bad': 'Cattivo',

  // Auth Page
  'auth.branding.headline1': 'Non tutte le idee sono buone.',
  'auth.branding.headline2': 'Te lo diciamo onestamente.',
  'auth.branding.subtitle': 'Un\'IA decisionale per nicchie di business. Chiara. Critica. Senza giri di parole.',
  'auth.benefits.privacy.title': '100% Privato',
  'auth.benefits.privacy.desc': 'Le tue idee rimangono completamente private e sicure.',
  'auth.benefits.honest.title': 'IA Onesta',
  'auth.benefits.honest.desc': 'Senza giri di parole – solo feedback chiaro e critico.',
  'auth.benefits.fast.title': 'Risultati Veloci',
  'auth.benefits.fast.desc': 'Ottieni chiarezza sulla tua nicchia in pochi minuti.',
  'auth.trust.users': 'Utenti Attivi',
  'auth.trust.ideas': 'Idee Analizzate',
  'auth.trust.rating': 'Valutazione',
  'auth.login.title': 'Accedi',
  'auth.login.headline': 'Bentornato',
  'auth.login.subtitle': 'Accedi per continuare il tuo percorso.',
  'auth.login.forgotPassword': 'Password dimenticata?',
  'auth.login.submit': 'Accedi',
  'auth.login.noAccount': 'Non hai un account?',
  'auth.login.signUp': 'Registrati',
  'auth.register.title': 'Registrati',
  'auth.register.headline': 'Crea il tuo account',
  'auth.register.subtitle': 'Inizia ad analizzare le tue idee di business oggi.',
  'auth.register.submit': 'Crea Account',
  'auth.register.hasAccount': 'Hai già un account?',
  'auth.register.signIn': 'Accedi',
  'auth.fields.name': 'Nome Completo',
  'auth.fields.email': 'Indirizzo Email',
  'auth.fields.password': 'Password',
  'auth.fields.confirmPassword': 'Conferma Password',
  'auth.fields.selectPlan': 'Seleziona il tuo piano',
  'auth.placeholders.name': 'Inserisci il tuo nome',
  'auth.placeholders.email': 'Inserisci la tua email',
  'auth.placeholders.password': 'Inserisci la tua password',
  'auth.placeholders.confirmPassword': 'Conferma la tua password',
  'auth.terms.accept': 'Accetto i',
  'auth.terms.terms': 'Termini e Condizioni',
  'auth.privacy.accept': 'Accetto la',
  'auth.privacy.policy': 'Politica sulla Privacy',
  'auth.errors.nameRequired': 'Il nome è obbligatorio',
  'auth.errors.emailRequired': 'L\'email è obbligatoria',
  'auth.errors.emailInvalid': 'Inserisci un\'email valida',
  'auth.errors.passwordRequired': 'La password è obbligatoria',
  'auth.errors.passwordLength': 'La password deve avere almeno 8 caratteri',
  'auth.errors.passwordMismatch': 'Le password non corrispondono',
  'auth.loading': 'Attendere prego...',
  'auth.or': 'o continua con',
  'auth.social.google': 'Continua con Google',
  'auth.social.apple': 'Continua con Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'Accesso gratuito di 3 giorni',
  'pricing.trial.credits': '250 crediti',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Nessun addebito per 3 giorni',
  'pricing.trial.cta': 'Inizia la prova gratuita',
  'pricing.trial.feature1': '250 crediti per esplorare l\'IA',
  'pricing.trial.feature2': 'Accesso completo per 3 giorni',
  'pricing.trial.feature3': 'Nessuna carta di credito richiesta',
  'pricing.trial.feature4': 'Annulla quando vuoi',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 crediti + report Builder di 25 pagine',
  'pricing.gold.credits': '10.000 crediti',
  'pricing.gold.feature1': '10.000 crediti',
  'pricing.gold.feature2': 'Report Builder di 25 pagine',
  'pricing.gold.feature3': 'Tutte le funzioni Starter e Pro',
  'pricing.gold.feature4': 'Analisi di mercato e sintesi',
  'pricing.gold.feature5': 'Opportunità, rischi, raccomandazioni',
  'pricing.gold.feature6': 'Scarica PDF',
  'pricing.gold.feature7': 'Supporto',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 crediti + report Builder di 100 pagine',
  'pricing.platinum.credits': '15.000 crediti',
  'pricing.platinum.feature1': '15.000 crediti',
  'pricing.platinum.feature2': 'Report Builder di 100 pagine',
  'pricing.platinum.feature3': 'Tutte le funzioni Gold',
  'pricing.platinum.feature4': 'Modalità Builder: briefing per sviluppatori',
  'pricing.platinum.feature5': 'Riepilogo strutturato',
  'pricing.platinum.feature6': 'Analisi di mercato avanzata',
  'pricing.platinum.feature7': 'Supporto',

  // Pricing UI
  'pricing.monthly': 'Mensile',
  'pricing.yearly': 'Annuale',
  'pricing.savings': 'di risparmio',
  'pricing.billedYearly': 'Fatturazione annuale',

  // Hero trial CTA
  'hero.trialTitle': 'Inizia la tua prova gratuita',
  'hero.creditsLabel': 'Crediti',
  'hero.trialTagline': 'Prova il nostro assistente IA gratis per 3 giorni',
  'hero.trialCta': 'Registrati e ottieni 250 crediti',
  'hero.trialNoCard': 'Nessuna carta di credito richiesta. Nessun impegno.',

  // Admin
  'admin.dashboard.tabs.plans': 'Piani',

  // Credit top-up
  'dashboard.credits.topup.button': 'Ricarica crediti',
  'dashboard.credits.topup.buttonTitle': 'Acquista più crediti senza cambiare piano',
  'dashboard.credits.topup.title': 'Ricarica crediti',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 per credito — nessun cambio piano',
  'dashboard.credits.topup.quickAmounts': 'Scelta rapida',
  'dashboard.credits.topup.custom': 'Personalizzato',
  'dashboard.credits.topup.totalLabel': 'Totale',
  'dashboard.credits.topup.creditsLabel': 'Crediti',
  'dashboard.credits.topup.confirm': 'Acquista ora',
  'footer.disclaimer': 'Avviso legale',
  'legal.backToHome': 'Torna alla home',
  'legal.lastUpdated': 'Ultimo aggiornamento',
  'legal.allRightsReserved': 'Tutti i diritti riservati.',
  'legal.authoritativeNotice': 'Una versione localizzata nella tua lingua non è ancora disponibile. Di seguito è mostrato il testo inglese che fa fede.',
  'legal.translationNotice': 'Questa è una traduzione di cortesia. La versione inglese è l’originale giuridicamente vincolante.',
};

export default common;
